import DefaultLayout from 'components/layouts/DefaultLayout';
import NotFound from '../src/app/NotFound';

const ErrorPage = () => (
  <DefaultLayout path="/404" name="404" white searchBar>
    <NotFound statusCode={404} />
  </DefaultLayout>
);

export default ErrorPage;
